import { render, staticRenderFns } from "./BCT.vue?vue&type=template&id=d01521a2&scoped=true&"
import script from "./BCT.vue?vue&type=script&lang=js&"
export * from "./BCT.vue?vue&type=script&lang=js&"
import style0 from "./BCT.vue?vue&type=style&index=0&id=d01521a2&lang=scss&scoped=true&"
import style1 from "./BCT.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01521a2",
  null
  
)

export default component.exports